import { useNavigation } from "@react-navigation/native"
import { StackNavigationProp } from "@react-navigation/stack"
import { Button, useTheme, VectorIcon } from "capsule"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { StyleSheet, View } from "react-native"
import { Text } from "react-native-paper"

import { PasswordModificationNS } from "../../features/i18n/constants"
import { RootParamList } from "../../features/Navigation/types"

const NeedNewPasswordScreen = () => {
  const {
    colors: {
      surface: { background },
      primary,
    },
    dimensions: { spacing },
  } = useTheme()
  const { t } = useTranslation(PasswordModificationNS)

  const navigation = useNavigation<StackNavigationProp<RootParamList, "PasswordModification">>()
  const s = useMemo(
    () => ({
      view: [
        styles.view,
        {
          backgroundColor: background,
          paddingHorizontal: spacing * 2,
        },
      ],
      section: styles.section,
      text: styles.text,
      button: styles.button,
    }),
    [background, spacing],
  )
  const handleStart = () => {
    navigation.navigate("PasswordModification")
  }
  return (
    <View style={s.view}>
      <View style={s.section}>
        <VectorIcon
          name="lock"
          category="MaterialCommunityIcons"
          style={styles.icon}
          size={125}
          color={primary}
        />
      </View>
      <View style={s.section}>
        <Text style={s.text}>{t("tooOldPassword")}</Text>
        <Button style={s.button} onPress={handleStart}>
          {t("labels.submit")}
        </Button>
      </View>
    </View>
  )
}

const styles = StyleSheet.create({
  view: {
    flex: 1,
    gap: 20,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  section: {
    gap: 16,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
  text: {
    textAlign: "center",
  },
  button: {
    width: "100%",
    height: 40,
  },
  icon: {
    marginBottom: 20,
  },
})

export default NeedNewPasswordScreen
